module.exports = "/images/chevron-up.svg?5b6fd08e72f3cd7048a2bf8e66e3ac7a";